module.exports = __webpack_public_path__ + "img/banner2.05b1da0b.png";